import { NgModule  } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { SharedModule } from './shared.module';
import { Logit } from './app.component';
import { IonicStorageModule } from '@ionic/storage';
import { Storage } from '@ionic/storage';

@NgModule({
  imports: [
    SharedModule,
    IonicModule.forRoot(Logit, {
      menuType: 'reveal'
    }),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  declarations: [
    Logit,
  ],
  entryComponents: [
    Logit,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts